import { Search } from "lucide-react";
import { ChangeEvent } from "react";
import { Input } from "./ui/input";

interface SearchComponentProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const SearchComponent = ({ onChange }: SearchComponentProps) => {
  return (
    <div className="relative w-full">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <Search size={16} className="text-muted-foreground" />
      </div>
      <Input
        onChange={onChange}
        placeholder="Search"
        className="pl-10 h-10 text-[13px] border-transparent bg-muted hover:bg-muted focus-visible:bg-muted placeholder:text-muted-foreground placeholder:text-opacity-50"
      />
    </div>
  );
};
